<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense style="background:#F5F5F5">
        <v-toolbar-title dense style="color:#607D8B;font-weight:bold">Absences non justifiées
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="refresh" icon>
          <v-icon color="#009688" large>mdi-refresh</v-icon>
          <template v-slot:loader>
            <span class="custom-loader"> <v-icon light>cached</v-icon></span>
          </template>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-dialog fullscreen v-model="loading">
          <v-container fill-height fluid style="background-color: rgba(200, 200, 200, 0.5);">
            <v-layout align-center="true" justify-center="true">
              <v-progress-circular
                  :on-cancel="onCancel"
                  :size="70"
                  color="#009688"
                  indeterminate>
              </v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>
        <v-alert :color=AlertColor(type)
                 :dismissible=true
                 :value=true
                 @input="dismissible_close"
                 border="top"
                 class="pre-formatted multi-line"
                 colored-border
                 elevation="2"
                 icon="check_circle"
                 style="color: #546E7A"
                 v-if="type">
          {{ text }}
        </v-alert>
        <v-alert border="top" class="my-4" color="#F44336" dark dense v-if="errors.length>0"
                 v-model="alert">
          <h4 class="mt-2">{{ errors.length }}{{ " Erreur" | pluralize(errors.length) }}
            sur {{ excelData.length }} {{ "enregistrement"|pluralize(excelData.length) }}.
            Merci de corriger et de ne réimporter que les enregistrements ci-dessous rejetés, pour éviter
            tout doublon
          </h4>
          <v-row align="center">
            <v-col class="grow">
              <div :key="index" v-for="(error,index) in errors">
                <h5>
                  <v-icon>mdi-alert-circle</v-icon>
                  {{ "Matricule (" + error.datas.userId + ") -> " + error.message }}
                </h5>
              </div>
            </v-col>
            <v-col class="shrink">
              <v-btn :elevation="1" @click="closeAlert" fab small
                     style="position:absolute;top:18px;right:12px">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-alert>
        <modal :adaptive=true
               :clickToClose="false"
               :draggable=false
               :resizable=false
               height="auto"
               name="modal-fade-observations">
          <v-card>
            <v-toolbar
                color="primary"
                dark
                flat>
              <v-text-field :id="dynamicID()" class="text--darken-3 mt-3"
                            dense
                            hide-details
                            label="Fenêtre de saisie"
                            readonly
                            rounded>
              </v-text-field>
              <v-spacer></v-spacer>
              <v-btn
                  @click="hide()"
                  dark
                  fab
                  small>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-container>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="12" sm="12">
                    <v-text-field :id="dynamicID()"
                                  class="centered-input align-center"
                                  color="#01579B" label="0bservations" rows="1"
                                  textarea
                                  v-model="absenceObservations"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-container>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="Annuler"
                     class="white--text"
                     color="#01579B" depressed>Annuler
              </v-btn>
              <v-btn :disabled="!FormIsValid && !loading" @click="Valider"
                     class="white--text"
                     color="#01579B" depressed>Créer Absence
              </v-btn>
            </v-card-actions>
          </v-card>
        </modal>
        <v-card class="mt-1" flat
                tile>
          <v-row>
            <v-col>
              <v-select :items="selectDates" @change="depthDate" dense filled full-width
                        hide-details="true"
                        item-text="name"
                        item-value="value" return-object solo style="z-index: 200"
                        v-model="depthVal">
                <template v-slot:selection="{ item }">
                                      <span class="d-flex justify-center" style="width: 100%;">
                                        {{ item.name }}
                                      </span>
                </template>
              </v-select>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col>
              <v-text-field :id="dynamicID()"
                            @change="search"
                            @keyup.native.enter="search"
                            @click:clear="cleared()"
                            append-icon="mdi-magnify"
                            class="centered-input align-center"
                            clearable
                            hide-details
                            placeholder="Recherche"
                            v-model="searchName">
              </v-text-field>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col>
              <v-btn @click="onexportNbrAbsences" block class="custom-btn white--text" color="#03A9F4"
                     height="45px"
                     large>
                <v-icon class="mr-1">mdi-file-export-outline</v-icon>
                <span>Export (Thalia)</span>
              </v-btn>
            </v-col>
            <v-col>
              <v-btn @click="onexport" block class="custom-btn white--text" color="#00BCD4" height="45px"
                     large>
                <v-icon class="mr-1">mdi-file-excel-outline</v-icon>
                <span>Export rapport</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mt-4"
                elevation="6">
          <hot-table :settings="hotSettings" ref="hotTable"></hot-table>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import {HotTable} from "@handsontable/vue";
import "handsontable/languages/fr-FR";
import moment from "moment"
import "vue-loading-overlay/dist/vue-loading.css";
import {depthDate} from "../../../helper/profondeur";
import * as XLSX from 'xlsx';
import Handsontable from "handsontable";
import apiClient from "../../../config/api.js";

function cellProblemRenderer(hotInstance, td, row, column, prop, value, cellProperties) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  td.className = "colProblem";
}

function customDropDownRender(instance, td, row, col, prop, value, cellProperties) {
  Handsontable.renderers.AutocompleteRenderer.apply(this, arguments);
  cellProperties.data = 'options';
  cellProperties.type = 'dropdown';

  if (col === 9) {
    cellProperties.source = JSON.parse(sessionStorage.getItem("RaisonsAbsences"))
  }
}

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  name: "AbsencesNonJustifiees",
  components: {HotTable},
  data: function () {
    return {
      isMobile: isMobileDevice(),
      disableMainBtn: false,
      searchName: "",
      lastHighlitedRow: null,
      loading: false,
      selectDates: depthDate,
      depthVal: {
        name: sessionStorage.getItem("depthValChoosedt"),
        value: sessionStorage.getItem("depthValChoosedd")
      },
      absenceObservations: "",
      editedItem: {
        userId: "",
        reasonAbsence: "",
        startDate: "",
        endDate: "",
        absenceObservations: "",
        onGoing: ""
      },
      tab: null,
      dialog: false,
      type: "",
      alert: false,
      errors: [],
      arrayAbs: [],
      fullPage: false,
      text: "",
      color: "",
      toObject: [],
      hotSettings: {
        renderAllRows: false,          // Rendu virtuel
        viewportRowRenderingOffset: 'auto',  // Calcul dynamique
        data: [],
        colWidths: 100,
        width: "100%",
        height: "675px",
        fixedRowsTop: 0,
        columnSorting: true,
        sortIndicator: true,
        filters: true,
        dropdownMenu: ["filter_by_condition", "filter_action_bar", "filter_operators", "filter_by_value"],
        licenseKey: "non-commercial-and-evaluation",
        stretchH: "all",
        selectionMode: "single",
        minSpareRows: false,
        language: "fr-FR",
        customBorders: true,
        columnHeaders: true,
        rowHeaders: true,
        stretch: "all",
        className: "htCenter htMiddle",
        manualColumnResize: true,
        readOnly: false,
        afterChange: this.afterChangeMe,
        afterFilter: this.afterFilter,
        afterLoadData: this.afterLoadData,
        currentRowClassName: 'rowHighlight',
        hiddenColumns: {
          columns: [8, 10],
          indicators: false
        },
        colHeaders: [
          "Matricule", "Nom", "Prénom", "Brigade", "Nom Shift", "Date début", "Date fin", "EnCours",
          "Plannifiée", "Raison absence", "Observations", "Date création", "Matricule créateur"
        ],
        columns: [
          {title: "Matricule", width: "150px", readOnly: true},
          {title: "Nom", width: "160px", readOnly: true},
          {title: "Prénom", width: "200px", readOnly: true},
          {title: "Brigade", width: "160px", readOnly: true},
          {title: "Shift", width: "160px", readOnly: true},
          {
            title: "Date début",
            width: "180px",
            type: "date",
            dateFormat: "DD-MM-YYYY",
            correctFormat: true,
            readOnly: true

          },
          {
            title: "Date fin",
            width: "180px",
            type: "date",
            dateFormat: "DD-MM-YYYY",
            correctFormat: true,
            readOnly: true
          },
          {title: "EnCours", width: "120px", type: "checkbox", readOnly: true},
          {title: "Plannifiée", width: "120px", type: "checkbox", readOnly: true},
          {
            title: "Raison absence",
            width: "300px",
            type: "dropdown",
            renderer: customDropDownRender,
            allowInvalid: false,
            strict: true
          },
          {title: "Observations", width: "180px", readOnly: true},
          {
            title: "Date création",
            width: "180px",
            dateFormat: "DD-MM-YYYY HH:mm:ss",
            correctFormat: true,
            type: "date",
            readOnly: true
          },
          {title: "Matricule créateur", width: "160px", readOnly: true}
        ],
        cells: function (row, col, prop) {
          const cellProperties = {};

          if (col === 0) {
            const cellValue = this.instance.getSourceDataAtCell(row, 10);
            if (cellValue === "Présence constatée") {
              cellProperties.renderer = cellProblemRenderer;
            }
          }

          return cellProperties;
        }
      }
    }
  },

  computed: {
    FormIsValid() {
      return (
          this.absenceObservations !== ""
      );
    },
  },

  created() {
    this.depthDate()
    this.loadAbsencesTypes()
  },

  methods: {
    cleared() {
      this.searchName = "";
      this.getData();
    },
    search() {
      var query = this.isEmpty(this.searchName) ? this.searchName : this.searchName.toLowerCase()

      if (this.isEmpty(query)) {
        this.cleared()
      }

      var row;
      var col;
      var rLen;
      var cLen;
      var data = this.$refs.hotTable.hotInstance.getData();
      var array = [];
      for (row = 0, rLen = data.length; row < rLen; row++) {
        for (col = 0, cLen = Object.keys(data[row]).length; col < cLen; col++) {
          var x = Object.keys(data[row])[col];
          if (('' + data[row][x]).toLowerCase().indexOf(query) > -1) {
            array.push(data[row]);
            break;
          }
        }
      }
      this.$refs.hotTable.hotInstance.loadData(array);
    },
    loadAbsencesTypes() {
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/account/absencetypes/` +
              sessionStorage.getItem("userId"), {timeout: 360000}
          )
          .then(response => {
            sessionStorage.setItem("RaisonsAbsences", null)
            let datas = response.data.datas;
            this.absencetypes = datas;
            datas.forEach(item => {
              this.arrayAbs.push(item.type)
            })
            sessionStorage.setItem("RaisonsAbsences", JSON.stringify(this.arrayAbs))
          })
          .catch(() => {
          });
    },
    afterSelectionEnd(r, c) {
      var i;
      if (this.lastHighlitedRow !== null) {
        for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
          this.$refs.hotTable.hotInstance.setCellMeta(this.lastHighlitedRow, i, 'className', 'htCenter htMiddle');
        }
      }

      for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
        this.$refs.hotTable.hotInstance.setCellMeta(r, i, 'className', 'area highlight, htCenter htMiddle');
      }
      this.lastHighlitedRow = r;

      this.$refs.hotTable.hotInstance.render()
    },
    depthDate() {
      if (this.depthVal) {
        sessionStorage.setItem("depthValChoosedd", this.depthVal.value)
        sessionStorage.setItem("depthValChoosedt", this.depthVal.name)
      }
      this.getData(this.depthVal)
    },
    isEmpty(str) {
      return (!str || 0 === str.length || /^\s*$/.test(str));
    },
    getData(valeur) {
      this.loading = true
      valeur = this.depthVal.value
      console.log("Start time " + moment().format("HH:mm:ss"))
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/reports/absencesnotpredictedreportbydatedepth/` + moment().subtract(valeur, "days").format("YYYY-MM-DD") + "/" + sessionStorage.getItem("userId")
          )
          .then(response => {
            console.log("End time " + moment().format("HH:mm:ss"))
            this.loading = false
            let tabArray = []
            let newObj = response.data.datas;

            if (response.data.status !== 200) {
              this.color = "#009688"
              this.text = response.data.message;
              this.showAlert('warning')
              this.disableMainBtn = true
            } else {
              this.disableMainBtn = false
            }

            String.prototype.capitalize = function (allWords) {
              return (allWords) ? // if all words
                  this.split(' ').map(word => word.capitalize()).join(' ') : //break down phrase to words then  recursive calls until capitalizing all words
                  this.charAt(0).toUpperCase() + this.slice(1); // if allWords is undefined , capitalize only the first word , mean the first char of the whole string
            }

            newObj.forEach((item) => {
              tabArray.push([
                item["userId"],
                this.isEmpty(item["accountLastname"]) ? "" : item["accountLastname"].toUpperCase(),
                this.isEmpty(item["accountFirstname"]) ? "" : item["accountFirstname"].toLowerCase().capitalize(true),
                this.isEmpty(item["brigade"]) ? "" : item["brigade"].toUpperCase(),
                item["shiftName"],
                moment(item["startDate"], "YYYY-MM-DD").format("DD-MM-YYYY"),
                moment(item["endDate"], "YYYY-MM-DD").format("DD-MM-YYYY"),
                item["onGoing"],
                item["plannifiee"],
                item["reasonAbsence"],
                item["absenceObservations"],
                item["creationDate"] !== null ? moment(item["creationDate"]).format("DD-MM-YYYY HH:mm:ss") : "",
                item["originUser"]
              ])
            })

            this.$refs.hotTable.hotInstance.loadData(tabArray)
            this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()];
          })

          .catch(error => {
            console.log("End error " + error)
            this.loading = false
          });
    },
    show() {
      this.$modal.show('modal-fade-observations');
    },
    hide() {
      this.depthDate()
      this.$modal.hide('modal-fade-observations');
    },
    AlertColor(type) {
      return type === "info" ? "#4CAF50" : "#F44336";
    },
    showAlert(type) {
      this.type = type

      let timer = this.showAlert.timer
      if (timer) {
        clearTimeout(timer)
      }
      this.showAlert.timer = setTimeout(() => {
        this.type = null
      }, 20000)

      this.elapse = 1
      let t = this.showAlert.t
      if (t) {
        clearInterval(t)
      }

      this.showAlert.t = setInterval(() => {
        if (this.elapse === 3) {
          this.elapse = 0
          clearInterval(this.showAlert.t)
        } else {
          this.elapse++
        }
      }, 5000)
    },
    dismissible_close() {
      this.elapse = 3
      clearTimeout(this.showAlert.timer)
      clearInterval(this.showAlert.t)
      this.type = null
    },
    closeAlert() {
      this.alert = false
      this.text = ""
      this.errors = []
    },
    Annuler() {
      this.hide()
      this.absenceObservations = ""
    },
    Valider() {
      this.hide()

      this.loading = true
      const dataToSave = {
        userId: this.editedItem.userId,
        startDate: this.editedItem.startDate,
        endDate: this.editedItem.endDate,
        reasonAbsence: this.editedItem.reasonAbsence,
        absenceObservations: this.isEmpty(this.absenceObservations) ? this.editedItem.absenceObservations : this.absenceObservations,
      };
      apiClient
          .post(`${this.$store.getters.user.baseUrl}/account/absence/` + sessionStorage.getItem("userId"),
              dataToSave
          )
          .then(res => {
            this.loading = false
            if (res.data.status === 200) {
              this.absenceObservations = ""
              this.color = "#009688"
              this.text = res.data.message
              this.dialog = false;

              this.showAlert('info')
              this.depthDate();
            } else {
              this.alert = true
              this.color = "#F44336"
              this.alert = true
              this.text = res.data.message;
              this.dialog = false;

              this.showAlert('warning')
              this.depthDate();
            }
          })
          .catch(error => {
            this.absenceObservations = ""
            this.alert = true
            this.text = error;
            this.dialog = false;
            this.loading = false
            this.color = "#F44336"

            this.showAlert('warning')
            this.depthDate();
          });
    },
    dynamicID() {
      return 'dynamicID-' + Math.floor(Math.random() * Date.now().toString());
    },
    afterChangeMe(changes, source) {
      if (changes !== null && source === "edit" && (changes[0][2] !== changes[0][3])) {
        let message = {
          title: 'Fenêtre de confirmation',
          body: 'Confirmez la modification de l\'absence non justifiée.'
        };

        this.$dialog
            .confirm(message)
            .then(dialog => {
              this.loading = true
              let obj = {}
              obj = this.$refs.hotTable.hotInstance.getData()[changes[0][0]]

              let sdate = moment(obj[5], "DD-MM-YYYY").format("YYYY-MM-DD HH:mm:ss")
              let edate = moment(obj[6], "DD-MM-YYYY").format("YYYY-MM-DD HH:mm:ss")

              if ((sdate === "Invalid date") || (edate === "Invalid date")) {
                this.text = "Date & Heure invalide -> Ligne " + (changes[0][0] + 1) +
                    ".\nLes dates doivent être au format DATE et les heures au format HEURE (cf modèle)."

                this.showAlert('warning')
                this.loading = false
                this.refresh()
                dialog.close();
                return;
              }

              this.editedItem.userId = obj[0]
              this.editedItem.startDate = moment(obj[5], "DD-MM-YYYY").format("YYYY-MM-DD HH:mm:ss")
              this.editedItem.endDate = moment(obj[6], "DD-MM-YYYY").format("YYYY-MM-DD HH:mm:ss")
              this.editedItem.reasonAbsence = obj[9]
              this.editedItem.absenceObservations = obj[10]

              dialog.close();
              this.show()
            })
            .catch(() => {
              let myData = this.$refs.hotTable.hotInstance.getData()
              myData[changes[0][0]][changes[0][1]] = changes[0][2]
              this.$refs.hotTable.hotInstance.loadData(myData)
            });
      }
    },
    onCancel() {
      this.loading = false
    },
    refresh() {
      this.getData(this.depthVal)
    },
    afterLoadData() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()];
    },
    afterFilter() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()];
    },

    onexport() { // On Click Excel download button
      // export json to Worksheet of Excel
      // only array possible
      this.loading = true
      var datas = XLSX.utils.json_to_sheet(this.toObject, {skipHeader: true})
      // var pokemonWS = XLSX.utils.json_to_sheet(this.Datas.pokemons)

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, datas, "Absences_non_justifiées") // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, "pokemons")

      // export Excel file
      XLSX.writeFile(wb, "Absences_non_justifiées.xlsx") // name of the file is "book.xlsx"
      this.loading = false
    },

    pad(n, width, z) {
      z = z || '0';
      n = n + '';
      return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    },

    onexportNbrAbsences() { // On Click Excel download button
      class Counter extends Map {
        constructor(iter, key = null) {
          super();
          this.key = key || (x => x);
          for (let x of iter) {
            this.add(x);
          }
        }

        add(x) {
          x = this.key(x);
          this.set(x, (this.get(x) || 0) + 1);
        }
      }

      var resultANJ = this.toObject.filter((x) => {
        return x[9] === 'Absence non justifiée'
      });

      //console.log("Résultat avec doublons : " + result);
      var uniqueANJ = resultANJ.filter((item, pos, self) => self.findIndex(v => v[0] === item[0]) === pos);
      //console.log("Résultat sans doublons : " + unique);

      let byMatANJ = new Counter(resultANJ, x => x[0]);
      //console.log("byMat", byMat);

      var datasTmpANJ = []

      let i = 0
      let sommeANJ = 0
      for (var [clefANJ, valeurANJ] of byMatANJ) {
        datasTmpANJ.push([
          this.pad(clefANJ, 3),
          uniqueANJ[i][1] + " " + uniqueANJ[i][2],
          valeurANJ
        ])
        sommeANJ += valeurANJ
        ++i;
      }
      datasTmpANJ.push([
        "",
        "",
        ""
      ])
      datasTmpANJ.push([
        "",
        "Total",
        sommeANJ
      ])

      datasTmpANJ = [["Matricule", "Nom & Prénom", "Absence non justifiée"], ...datasTmpANJ];
      var datasANJ = XLSX.utils.json_to_sheet(datasTmpANJ, {origin: 'A1', skipHeader: true})

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, datasANJ, "Absence non justifiée") // sheetAName is name of Worksheet

      // export Excel file
      XLSX.writeFile(wb, "Export_Thalia_Absenses_Non_Justifiées.xlsx") // name of the file is "book.xlsx"
      this.loading = false
    }
  }
};
</script>

<style scoped>
.toolbar .v-toolbar__content {
  padding: 0 !important
}

.input-class {
  padding: 2px 0;
  border-bottom: solid 1px #999;
  color: #444;
  width: 100%;
}

.v-text-field {
  min-width: 222px;
}

.custom-btn {
  width: 222px;
}

.custom-btn::before {
  color: transparent
}

.custom-btn:hover {
  color: #F5F5F5 !important;
}

.handsontable .yellow {
  background-color: #faec8f;
}

.colProblem {
  text-align: center;
  background-color: yellow !important;
  font-weight: bold !important;
  font-style: normal !important;
}
</style>